/** Helpers for linking Products/Services to الفئات (facturation_categories). */

import localApiAdapter from '../../core/services/localApiAdapter';

export const CATALOG_CATEGORIES_REFRESH_EVENT = 'refresh-categories';

export function notifyCatalogCategoriesChanged() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(CATALOG_CATEGORIES_REFRESH_EVENT));
  }
}

export function normalizeCategoriesResponse(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
}

/** Live API fetch for category pickers (product / service scoped). */
export async function fetchCatalogCategories(type = 'product') {
  try {
    const response = await localApiAdapter.get(type ? `/categories?type=${type}` : '/categories');
    return filterCategoriesByType(normalizeCategoriesResponse(response), type);
  } catch (error) {
    console.error('Error loading catalog categories:', error);
    return [];
  }
}

export function filterCategoriesByType(categories, type) {
  const list = Array.isArray(categories) ? categories : [];
  if (!type) return list;
  if (type === 'product') {
    return list.filter((cat) => cat.type === 'product' || !cat.type);
  }
  return list.filter((cat) => cat.type === type);
}

export function findCategoryByRef(categories, ref) {
  if (!ref) return null;
  const list = Array.isArray(categories) ? categories : [];
  const refStr = String(ref);
  return (
    list.find((c) => c.id === refStr)
    || list.find((c) => c.category_number === refStr)
    || list.find((c) => c.name === refStr)
    || null
  );
}

export function resolveCategoryLabel(ref, categories, { emptyLabel = '—' } = {}) {
  if (!ref) return emptyLabel;
  const hit = findCategoryByRef(categories, ref);
  return hit?.name || ref;
}

export function categoryRecordMatchesRef(recordCategory, ref, categories) {
  if (!ref || ref === 'all') return true;
  if (!recordCategory) return false;
  if (recordCategory === ref) return true;
  const cat = findCategoryByRef(categories, ref);
  if (cat && recordCategory === cat.name) return true;
  const recordCat = findCategoryByRef(categories, recordCategory);
  return recordCat?.id === ref;
}

export function buildCategorySelectOptions(categories, t, {
  includeClear = false,
  clearLabelKey = 'modules.article.pages.services.labels.no_category',
  clearValue = '__clear__',
} = {}) {
  const list = Array.isArray(categories) ? categories : [];
  const options = list.map((cat) => ({
    value: cat.id,
    label: cat.name,
  }));
  if (includeClear) {
    return [
      { value: clearValue, label: t(clearLabelKey) },
      ...options,
    ];
  }
  return options;
}
